import {
    Component,
    Input,
} from '@angular/core';
import { isMobile } from '../../../../../shared/helpers/utils/is-mobile';

@Component({
    selector: 'download-app',
    templateUrl: './download-app.component.html',
    styleUrls: ['./download-app.component.scss'],
})
export class DownloadAppComponent {
    @Input()
    public onContinueClick: () => void;

    public isMobile: boolean = false;

    constructor() {
        this.isMobile = isMobile();
    }
}
